import { FC } from 'react'

import { useDecision } from '@optimizely/react-sdk'

import { Modal } from '@tribeplatform/react-ui-kit/Modal'
import { Tabs } from '@tribeplatform/react-ui-kit/Tabs'

import { FeaturesList } from '../../lib/optimizely/feature.list'
import { PostEmbedCreator } from './PostEmbedCreator'
import { ShareLink, ShareLinkType } from './ShareLink'
import { ShareRss } from './ShareRss'
import { SpaceEmbedCreator } from './SpaceEmbedCreator'

export const ShareModal: FC<
  ShareLinkType & {
    open: boolean
    onClose: () => void
    postId?: string
    spaceId?: string
    memberId?: string
  }
> = ({ open, onClose, isPrivate, url, title, postId, spaceId, memberId }) => {
  const [decision] = useDecision(FeaturesList.PostEmbedCreator)
  const hasRSS = postId || spaceId || memberId
  const hasEmbed = (spaceId || postId) && decision.enabled
  return (
    <Modal
      showZenModeBtn
      open={open}
      onClose={onClose}
      className="inline-flex flex-col sm:m-0"
    >
      <Tabs.Group>
        <Modal.Header>
          <Tabs.List variant="pills">
            <Tabs.Tab>Share</Tabs.Tab>
            {hasEmbed && <Tabs.Tab>Embed</Tabs.Tab>}
            {hasRSS && <Tabs.Tab>RSS</Tabs.Tab>}
          </Tabs.List>
        </Modal.Header>

        <Modal.Content
          padding={false}
          className="px-4 sm:px-6 pb-6 pt-1 w-full mx-auto overflow-auto"
        >
          <Tabs.Panels>
            <Tabs.Panel>
              <ShareLink url={url} title={title} isPrivate={isPrivate} />
            </Tabs.Panel>
            {hasEmbed && (
              <Tabs.Panel>
                {postId ? (
                  <PostEmbedCreator postId={postId} />
                ) : (
                  <SpaceEmbedCreator spaceId={spaceId} />
                )}
              </Tabs.Panel>
            )}
            {hasRSS && (
              <Tabs.Panel>
                <ShareRss
                  postId={postId}
                  memberId={memberId}
                  spaceId={spaceId}
                  isPrivate={isPrivate}
                />
              </Tabs.Panel>
            )}
          </Tabs.Panels>
        </Modal.Content>
      </Tabs.Group>
    </Modal>
  )
}
